<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Llama-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Verify Expenses'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<div data-content-area="content" data-defined-in="Llama.VerifyExpenses">
							<ng-container
								*ngFor="let item of screen.expenses; let itemIndex = index; trackBy: trackByAutomatic"
							>
								<ng-container *lowgileScope="item; as: 'item'; let $scope">
									<ng-container
										*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
									>
										<div
											class="layout-block block"
											style="padding: 1.5rem"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<mat-expansion-panel
												[expanded]="true"
												[style.flex]="'1'"
												[hideToggle]="!(true)"
											>
												<mat-expansion-panel-header>
													<mat-panel-title>
														<span
															[innerHtml]="item.name | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</mat-panel-title>
												</mat-expansion-panel-header>
												<h5
													[innerHtml]="item.description | escapeHtml: 'none' | replaceNewlines: 'h5'"
												></h5>
												<Llama-ExpenseCardInclude
													[expense]="item"
													[projectsOptions]="screen.projectsOptions"
													(onVerified)="action_loadExpenses($event)"
												></Llama-ExpenseCardInclude>
											</mat-expansion-panel>
										</div>
									</ng-container>
								</ng-container>
							</ng-container>
						</div>
					</ng-template>
				</Llama-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
